import { orderBy } from 'lodash';
export const sortByParams = (_orderBy: 'asc' | 'desc', dataSource: any, sortType: string) => {
  let sortedArray = [];
  if (_orderBy && sortType && dataSource) {
    sortedArray = orderBy(dataSource, sortType, [_orderBy]);
  }
  return sortedArray;
};
